export default "__VITE_ASSET__fxAOTO$l__"